import { render, staticRenderFns } from "./attachmentUpload2.vue?vue&type=template&id=ced76f16"
import script from "./attachmentUpload2.vue?vue&type=script&lang=js"
export * from "./attachmentUpload2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports